import { Component, Input } from '@angular/core';
import { CardElementsBaseComponent } from '../card-elements-base.component';
import { WorkflowService } from '../../../../service/workflow/workflow.service';

@Component({
  selector: 'cu-dynamic-card-fields',
  templateUrl: './card-fields.component.html',
  standalone: false
})
export class CardFieldsComponent extends CardElementsBaseComponent {
  @Input() public cardId;

  constructor(private readonly workflowService: WorkflowService) {
    super();
  }
}
